(function () {
  'use strict';

  var enabled = window.theme && window.theme.settings && window.theme.settings.enable_related_by_custom_id;
  if (!enabled) return;
  if (!document.body.classList.contains('template-product')) return;

  var LOADING_BODY_CLASS = 'lop-pdp-color-swap--loading';
  var LOADING_SWATCH_CLASS = 'product-related-by-id__swatch--loading';
  var isLoading = false;
  var pageHtmlCache = new Map();
  var prefetchInFlight = new Map();
  var prefetchTimers = new WeakMap();
  var imagePreloadCache = new Set();
  var MOBILE_MAX_WIDTH = 768;
  var SCROLL_RESTORE_KEY = 'lop-pdp-color-swap-scroll-y';

  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return url;
    }
  }

  function getSectionDomId(sectionEl) {
    if (!sectionEl || !sectionEl.id) return null;
    var match = sectionEl.id.match(/^shopify-section-(.+)$/);
    return match ? match[1] : null;
  }

  function getMainContentSectionIds(doc) {
    var main = doc.getElementById('main-content');
    if (!main) return [];
    return Array.from(main.querySelectorAll('.shopify-section'))
      .map(getSectionDomId)
      .filter(Boolean);
  }

  function collectScripts(sectionEl) {
    return Array.from(sectionEl.querySelectorAll('script')).map(function (script) {
      return {
        src: script.getAttribute('src') || '',
        text: script.textContent || '',
        type: script.getAttribute('type') || ''
      };
    });
  }

  function runInlineScripts(sectionEl, scripts) {
    scripts.forEach(function (data) {
      // Skip external scripts and any non-JavaScript types.
      // application/json and application/ld+json must NOT be executed as JS —
      // executing JSON as JavaScript causes SyntaxErrors.
      var isJs = !data.type || data.type === 'text/javascript' || data.type === 'application/javascript';
      if (data.src || !isJs) return;
      if (!data.text.trim()) return;

      var text = data.text.trim();

      // Sections often wrap setup code in a DOMContentLoaded listener which will
      // never re-fire after an AJAX swap. We temporarily patch
      // document.addEventListener so any 'DOMContentLoaded' callback is called
      // immediately, leaving the rest of the script text completely unmodified
      // (avoids the fragile regex body-extraction that caused SyntaxErrors).
      var hasDomReady = text.indexOf('DOMContentLoaded') !== -1;
      var scriptText = hasDomReady
        ? '(function(){'
          + 'var _lop_orig=document.addEventListener;'
          + 'document.addEventListener=function(e,fn,o){'
          + 'if(e==="DOMContentLoaded"){try{fn();}catch(err){console.warn("[LOP] DOMContentLoaded inline error",err);}}'
          + 'else{_lop_orig.call(document,e,fn,o);}};'
          + 'try{' + text + '}finally{document.addEventListener=_lop_orig;}'
          + '})();'
        : text;

      try {
        var scriptEl = document.createElement('script');
        scriptEl.textContent = scriptText;
        sectionEl.appendChild(scriptEl);
      } catch (scriptErr) {
        console.warn('[LOP] inline script error', scriptErr);
      }
    });
  }

  function removeOrphanStickyBar() {
    document.querySelectorAll('body > product-add-to-cart-sticky').forEach(function (el) {
      el.remove();
    });
  }

  function replaceSectionFromDoc(doc, sectionId) {
    var newSection = doc.getElementById('shopify-section-' + sectionId);
    var currentSection = document.getElementById('shopify-section-' + sectionId);
    if (!newSection || !currentSection) return false;

    var scripts = collectScripts(newSection);

    // Remove executable scripts before adopting — they'll be re-run via runInlineScripts.
    // application/json scripts stay: custom elements read variant data from them.
    newSection.querySelectorAll('script:not([type="application/json"])').forEach(function (s) {
      s.remove();
    });

    // Use adoptNode + appendChild instead of innerHTML.
    //
    // With innerHTML the browser parses content into a DISCONNECTED document fragment first,
    // so custom element constructors run before the element has any ancestors in the live DOM.
    // product.js VariantSelects does `this.closest('.thb-product-detail')` in its constructor,
    // which returns null in the disconnected context → TypeError.
    //
    // With adoptNode the node is moved into the live document. Upgrade (constructor call)
    // happens during appendChild, at which point the full ancestor hierarchy is already
    // in the DOM → closest() finds .thb-product-detail correctly.
    var adopted = document.adoptNode(newSection);

    // Clear existing children of the wrapper (keep the wrapper element itself to preserve id).
    while (currentSection.firstChild) {
      currentSection.removeChild(currentSection.firstChild);
    }

    // Append adopted children one by one. Each top-level child is inserted while its own
    // subtree is intact, so custom elements inside initialize with correct ancestors.
    while (adopted.firstChild) {
      currentSection.appendChild(adopted.firstChild);
    }

    runInlineScripts(currentSection, scripts);
    return true;
  }

  function updateHeadFromDoc(doc) {
    var newTitle = doc.querySelector('title');
    if (newTitle && newTitle.textContent) {
      document.title = newTitle.textContent;
    }

    var newCanonical = doc.querySelector('link[rel="canonical"]');
    var currentCanonical = document.querySelector('link[rel="canonical"]');
    if (newCanonical && currentCanonical) {
      currentCanonical.href = newCanonical.href;
    }

    var newDesc = doc.querySelector('meta[name="description"]');
    var currentDesc = document.querySelector('meta[name="description"]');
    if (newDesc && currentDesc) {
      currentDesc.setAttribute('content', newDesc.getAttribute('content') || '');
    }
  }

  function isMobileViewport() {
    return window.innerWidth < MOBILE_MAX_WIDTH;
  }

  function pickSrcFromLazyImg(img) {
    if (!img) return '';

    var srcset = img.getAttribute('data-srcset');
    if (!srcset) {
      return img.getAttribute('data-src') || img.getAttribute('src') || '';
    }

    var parts = srcset.split(',');
    var preferredWidths = isMobileViewport() ? ['375w', '690w', '840w'] : ['840w', '1380w', '690w', '375w'];

    for (var p = 0; p < preferredWidths.length; p++) {
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf(preferredWidths[p]) !== -1) {
          return parts[i].trim().split(/\s+/)[0];
        }
      }
    }

    if (parts.length) {
      return parts[parts.length - 1].trim().split(/\s+/)[0];
    }

    return img.getAttribute('data-src') || img.getAttribute('src') || '';
  }

  function preloadImageUrl(url) {
    if (!url || imagePreloadCache.has(url)) return;
    imagePreloadCache.add(url);

    if (imagePreloadCache.size > 48) {
      imagePreloadCache.clear();
    }

    var preload = new Image();
    preload.decoding = 'async';
    if ('fetchPriority' in preload) {
      preload.fetchPriority = 'high';
    }
    preload.src = url;
  }

  function extractPdpImageUrls(doc, limit) {
    if (!doc) return [];
    if (limit === undefined) limit = isMobileViewport() ? 3 : 5;

    var urls = [];
    var seen = {};

    function pushUrl(url) {
      if (!url || seen[url]) return;
      seen[url] = true;
      urls.push(url);
    }

    var gallery = doc.querySelector('.product-images');
    if (gallery) {
      var slideSelector = '.product-images__slide.is-active img.lazyload, .product-images__slide.is-initial-selected img.lazyload, .product-images__slide img.lazyload';
      gallery.querySelectorAll(slideSelector).forEach(function (img, index) {
        if (index >= limit) return;
        pushUrl(pickSrcFromLazyImg(img));
      });
    }

    doc.querySelectorAll('.product-add-to-cart-sticky--image img, .product-add-to-cart-sticky img').forEach(function (img) {
      pushUrl(img.getAttribute('src') || pickSrcFromLazyImg(img));
    });

    return urls;
  }

  function preloadPdpImagesFromDoc(doc) {
    extractPdpImageUrls(doc).forEach(preloadImageUrl);
  }

  function loadImageImmediately(img, highPriority) {
    if (!img || img.classList.contains('lazyloaded')) return;

    var srcset = img.getAttribute('data-srcset');
    if (srcset) {
      img.srcset = srcset;
      img.sizes = img.getAttribute('data-sizes') || 'auto';
      img.src = pickSrcFromLazyImg(img);
    } else {
      var dataSrc = img.getAttribute('data-src');
      if (dataSrc) {
        img.src = dataSrc;
      }
    }

    img.classList.remove('lazyload', 'lazyloading');
    img.classList.add('lazyloaded');
    img.loading = 'eager';
    if (highPriority && 'fetchPriority' in img) {
      img.fetchPriority = 'high';
    }

    if (typeof img.decode === 'function') {
      img.decode().catch(function () {});
    }
  }

  function loadPdpImagesAfterSwap() {
    var main = document.getElementById('main-content');
    if (!main) return;

    var eagerLimit = isMobileViewport() ? 3 : 2;
    var gallery = main.querySelector('.product-images');

    if (gallery) {
      var prioritySlides = gallery.querySelectorAll(
        '.product-images__slide.is-active img.lazyload, .product-images__slide.is-initial-selected img.lazyload'
      );
      prioritySlides.forEach(function (img, index) {
        loadImageImmediately(img, index === 0);
      });

      gallery.querySelectorAll('.product-images__slide img.lazyload').forEach(function (img, index) {
        if (index < eagerLimit) {
          loadImageImmediately(img, index === 0);
        }
      });
    }

    main.querySelectorAll('.product-add-to-cart-sticky--image img.lazyload, product-add-to-cart-sticky img.lazyload').forEach(function (img) {
      loadImageImmediately(img, true);
    });

    if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
      main.querySelectorAll('.lazyload').forEach(function (img) {
        lazySizes.loader.unveil(img);
      });
      lazySizes.loader.checkElems();
    }
  }

  function prefetchProductPage(url) {
    fetchProductPageHtml(url).catch(function () {});
  }

  function schedulePrefetch(swatch) {
    var existingTimer = prefetchTimers.get(swatch);
    if (existingTimer) window.clearTimeout(existingTimer);

    prefetchTimers.set(
      swatch,
      window.setTimeout(function () {
        prefetchProductPage(swatch.href);
      }, isMobileViewport() ? 0 : 80)
    );
  }

  function extractProductHandleFromUrl(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      var match = path.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function extractProductHandleFromDoc(doc) {
    if (!doc) return null;

    var canonical = doc.querySelector('link[rel="canonical"]');
    if (canonical && canonical.href) {
      var fromCanonical = extractProductHandleFromUrl(canonical.href);
      if (fromCanonical) return fromCanonical;
    }

    var productDetail = doc.querySelector('.thb-product-detail[data-handle]');
    if (productDetail && productDetail.dataset.handle) {
      return productDetail.dataset.handle;
    }

    return null;
  }

  /**
   * Aligns Shopify/theme product context after AJAX swap (preview bar, analytics, theme.settings).
   * Does not replace full page load; complements pushState + section swap for storefront UX.
   */
  function applyProductContext(product) {
    if (!product || !product.id) return;

    if (window.theme && window.theme.settings) {
      window.theme.settings.product_id = product.id;
    }

    if (window.meta && window.meta.product) {
      window.meta.product.id = product.id;
      window.meta.product.handle = product.handle;
      if (product.title) window.meta.product.title = product.title;
    }

    window.ShopifyAnalytics = window.ShopifyAnalytics || {};
    if (!window.ShopifyAnalytics.meta) {
      window.ShopifyAnalytics.meta = {};
    }
    if (!window.ShopifyAnalytics.meta.product) {
      window.ShopifyAnalytics.meta.product = {};
    }

    window.ShopifyAnalytics.meta.product.id = product.id;
    window.ShopifyAnalytics.meta.product.title = product.title;
    window.ShopifyAnalytics.meta.product.vendor = product.vendor;
    window.ShopifyAnalytics.meta.product.type = product.type;
    window.ShopifyAnalytics.meta.product.handle = product.handle;

    if (product.variants && product.variants.length) {
      window.ShopifyAnalytics.meta.product.variants = product.variants;
    }
  }

  var merchantPreviewMode = null;

  function computeMerchantPreviewContext() {
    var settings = window.theme && window.theme.settings;
    if (settings) {
      if (settings.merchant_preview_context) return true;
      if (settings.is_theme_editor) return true;
      if (settings.visual_preview_mode) return true;
    }
    if (window.Shopify && window.Shopify.designMode) return true;
    if (document.getElementById('OnlineStorePreviewBarNextData')) return true;
    if (document.querySelector('iframe#PBarNextFrame, #preview-bar-iframe, #admin-bar-iframe')) return true;
    if (window.location.hostname.indexOf('shopifypreview.com') !== -1) return true;
    return false;
  }

  /**
   * Merchant / theme editor / preview bar: Shopify binds "Editar producto" on first server render.
   * AJAX cannot update that iframe; a real navigation is the only reliable fix for staff.
   *
   * merchantPreviewMode:
   *   null  = not yet determined
   *   true  = merchant/preview context confirmed (stays true forever)
   *   false = NOT set explicitly; we always re-check on click so late-arriving bars are caught.
   */
  function isMerchantPreviewContext() {
    // Once confirmed, never re-check (bar doesn't disappear mid-session).
    if (merchantPreviewMode === true) return true;
    // Always re-evaluate until confirmed, to catch bars injected after initial load.
    return computeMerchantPreviewContext();
  }

  function watchForLatePreviewBar() {
    // Observe DOM for up to 8 s so that preview bars injected asynchronously are detected.
    // We don't cache the result here; isMerchantPreviewContext() re-evaluates on every click.
    var observer = new MutationObserver(function () {
      if (computeMerchantPreviewContext()) {
        merchantPreviewMode = true;
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 8000);
  }

  function saveScrollForStaffNavigation() {
    try {
      sessionStorage.setItem(SCROLL_RESTORE_KEY, String(window.scrollY || 0));
    } catch (e) {
      /* ignore */
    }
  }

  function restoreScrollAfterStaffNavigation() {
    try {
      var raw = sessionStorage.getItem(SCROLL_RESTORE_KEY);
      if (raw === null) return;
      sessionStorage.removeItem(SCROLL_RESTORE_KEY);
      var y = parseInt(raw, 10);
      if (isNaN(y)) return;
      window.requestAnimationFrame(function () {
        window.scrollTo(0, y);
      });
    } catch (e) {
      /* ignore */
    }
  }

  function navigateToProductForMerchant(url) {
    saveScrollForStaffNavigation();
    window.location.assign(url);
  }

  function syncShopifyAdminContext(productHandle) {
    if (!productHandle) return Promise.resolve(null);

    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    } else if (window.theme && window.theme.routes && window.theme.routes.root_url) {
      root = window.theme.routes.root_url;
    }
    root = root.replace(/\/$/, '');
    var productUrl = root + '/products/' + encodeURIComponent(productHandle) + '.js';

    return fetch(productUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (product) {
        if (!product || !product.id) return null;

        applyProductContext(product);

        document.dispatchEvent(
          new CustomEvent('lop-pdp-color-swap:admin-sync', {
            bubbles: true,
            detail: {
              productId: product.id,
              handle: product.handle,
              title: product.title
            }
          })
        );

        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function reinitializeAfterSwap(sectionIds) {
    removeOrphanStickyBar();
    loadPdpImagesAfterSwap();

    if (sectionIds && sectionIds.forEach) {
      sectionIds.forEach(function (sectionId) {
        document.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: sectionId }
          })
        );
      });
    }

    document.dispatchEvent(new CustomEvent('lop-pdp-color-swap:complete', { bubbles: true }));

    if (typeof addIdToRecentlyViewed === 'function') {
      addIdToRecentlyViewed();
    }

    window.dispatchEvent(new Event('resize'));

    if (isMobileViewport()) {
      window.setTimeout(loadPdpImagesAfterSwap, 120);
    }
  }

  async function fetchProductPageHtml(url) {
    var path = normalizePath(url);

    if (pageHtmlCache.has(path)) {
      return pageHtmlCache.get(path);
    }

    var pending = prefetchInFlight.get(path);
    if (pending) return pending;

    var request = fetch(path)
      .then(function (response) {
        if (!response.ok) throw new Error('Product page fetch failed');
        return response.text();
      })
      .then(function (html) {
        pageHtmlCache.set(path, html);
        if (pageHtmlCache.size > 8) {
          var firstKey = pageHtmlCache.keys().next().value;
          pageHtmlCache.delete(firstKey);
        }

        try {
          preloadPdpImagesFromDoc(new DOMParser().parseFromString(html, 'text/html'));
        } catch (preloadError) {
          /* ignore parse errors during preload */
        }

        return html;
      })
      .finally(function () {
        prefetchInFlight.delete(path);
      });

    prefetchInFlight.set(path, request);
    return request;
  }

  async function swapProductColor(url, clickedSwatch, updateHistory) {
    if (updateHistory === undefined) updateHistory = true;
    if (isLoading) return;

    var targetPath = normalizePath(url);
    if (targetPath === normalizePath(window.location.pathname)) return;

    isLoading = true;
    document.body.classList.add(LOADING_BODY_CLASS);
    if (clickedSwatch) clickedSwatch.classList.add(LOADING_SWATCH_CLASS);

    try {
      removeOrphanStickyBar();

      // Fetch failure (network error) → fallback to full navigation.
      var html;
      try {
        html = await fetchProductPageHtml(url);
      } catch (fetchError) {
        console.error('LOP PDP color swap: fetch failed', fetchError);
        window.location.href = url;
        return;
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sectionIds = getMainContentSectionIds(doc);

      if (!sectionIds.length) {
        console.error('LOP PDP color swap: no sections found');
        window.location.href = url;
        return;
      }

      preloadPdpImagesFromDoc(doc);

      sectionIds.forEach(function (sectionId) {
        try {
          replaceSectionFromDoc(doc, sectionId);
        } catch (sectionError) {
          console.error('LOP PDP color swap: section replace error', sectionId, sectionError);
        }
      });

      updateHeadFromDoc(doc);

      var handle = extractProductHandleFromUrl(url) || extractProductHandleFromDoc(doc);
      if (handle) {
        syncShopifyAdminContext(handle);
      }

      if (updateHistory && window.history && window.history.pushState) {
        window.history.pushState({ lopPdpColorSwap: true, url: targetPath, handle: handle }, '', url);
      }

      // Reinit errors (e.g. from custom-element callbacks on mobile) must not abort the swap.
      try {
        reinitializeAfterSwap(sectionIds);
      } catch (reinitError) {
        console.error('LOP PDP color swap: reinit error', reinitError);
      }

      document.dispatchEvent(
        new CustomEvent('lop-pdp-color-swap:changed', {
          bubbles: true,
          detail: { url: url, handle: handle }
        })
      );
    } catch (error) {
      // Unexpected error in outer flow: log but do not navigate.
      // Prevents a mobile-specific JS exception from causing a full page reload.
      console.error('LOP PDP color swap: unexpected error', error);
    } finally {
      isLoading = false;
      document.body.classList.remove(LOADING_BODY_CLASS);
      if (clickedSwatch) clickedSwatch.classList.remove(LOADING_SWATCH_CLASS);
    }
  }

  function getMerchantContextReason() {
    var s = window.theme && window.theme.settings;
    if (s && s.merchant_preview_context) return 'liquid:merchant_preview_context';
    if (s && s.is_theme_editor) return 'liquid:is_theme_editor';
    if (s && s.visual_preview_mode) return 'liquid:visual_preview_mode';
    if (window.Shopify && window.Shopify.designMode) return 'js:Shopify.designMode';
    if (document.getElementById('OnlineStorePreviewBarNextData')) return 'dom:OnlineStorePreviewBarNextData';
    if (document.querySelector('iframe#PBarNextFrame, #preview-bar-iframe, #admin-bar-iframe')) return 'dom:preview-iframe';
    if (window.location.hostname.indexOf('shopifypreview.com') !== -1) return 'url:shopifypreview.com';
    return null;
  }

  function onSwatchClick(event) {
    var swatch = event.target.closest('.product-related-by-id__swatch');
    if (!swatch) return;
    if (swatch.classList.contains('product-related-by-id__swatch--active')) return;

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || swatch.getAttribute('target') === '_blank') {
      return;
    }

    event.preventDefault();
    // stopPropagation prevents ghost clicks and double-handling on mobile.
    event.stopPropagation();

    var merchantReason = getMerchantContextReason();
    if (merchantReason) {
      console.log('[LOP] merchant context detected (' + merchantReason + '): navigating to', swatch.href);
      navigateToProductForMerchant(swatch.href);
      return;
    }

    console.log('[LOP] AJAX swap to', swatch.href);
    swapProductColor(swatch.href, swatch, true);
  }

  function onSwatchMouseOver(event) {
    if (isMobileViewport()) return;

    var swatch = event.target.closest('.product-related-by-id__swatch');
    if (!swatch) return;
    if (swatch.classList.contains('product-related-by-id__swatch--active')) return;

    schedulePrefetch(swatch);
  }

  function onSwatchTouchStart(event) {
    var swatch = event.target.closest('.product-related-by-id__swatch');
    if (!swatch) return;
    if (swatch.classList.contains('product-related-by-id__swatch--active')) return;

    schedulePrefetch(swatch);
  }

  function prefetchSiblingColorsOnIdle() {
    if (!isMobileViewport()) return;

    var swatches = document.querySelectorAll('.product-related-by-id__swatch:not(.product-related-by-id__swatch--active)');
    if (!swatches.length) return;

    var schedule = window.requestIdleCallback || function (callback) {
      window.setTimeout(callback, 1500);
    };

    schedule(function () {
      Array.prototype.slice.call(swatches, 0, 2).forEach(function (swatch, index) {
        window.setTimeout(function () {
          prefetchProductPage(swatch.href);
        }, index * 300);
      });
    });
  }

  function onSwatchMouseOut(event) {
    var swatch = event.target.closest('.product-related-by-id__swatch');
    if (!swatch) return;

    var existingTimer = prefetchTimers.get(swatch);
    if (existingTimer) {
      window.clearTimeout(existingTimer);
      prefetchTimers.delete(swatch);
    }
  }

  function onPopState(event) {
    if (!document.body.classList.contains('template-product')) return;
    if (!event.state || !event.state.lopPdpColorSwap) return;

    var url = event.state.url || window.location.pathname;
    if (normalizePath(url) === normalizePath(window.location.pathname)) {
      if (event.state.handle) {
        syncShopifyAdminContext(event.state.handle);
      }
      return;
    }

    swapProductColor(url, null, false);
  }

  function injectStyles() {
    if (document.getElementById('lop-pdp-color-swap-styles')) return;

    var style = document.createElement('style');
    style.id = 'lop-pdp-color-swap-styles';
    style.textContent =
      'body.lop-pdp-color-swap--loading #main-content{opacity:.72;pointer-events:none;transition:opacity .15s ease}' +
      '.product-related-by-id__swatch--loading{opacity:.55;pointer-events:none}';
    document.head.appendChild(style);
  }

  function syncInitialAdminContext() {
    var handle = extractProductHandleFromUrl(window.location.href);
    if (handle) {
      syncShopifyAdminContext(handle);
    }
  }

  function bind() {
    injectStyles();
    restoreScrollAfterStaffNavigation();
    watchForLatePreviewBar();
    if (!isMerchantPreviewContext()) {
      syncInitialAdminContext();
    }
    document.addEventListener('click', onSwatchClick, true);
    document.addEventListener('mouseover', onSwatchMouseOver, true);
    document.addEventListener('mouseout', onSwatchMouseOut, true);
    document.addEventListener('touchstart', onSwatchTouchStart, { passive: true, capture: true });
    window.addEventListener('popstate', onPopState);
    prefetchSiblingColorsOnIdle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
